import { HeaderPositionType, TextStyleType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class SWOTCategory extends BaseCategory {
    get name() {
        return "SWOT Analysis";
    }

    get type() {
        return SlideCategories.SWOT;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The content is a SWOT analysis (Strengths, Weaknesses, Opportunities, Threats). Use this for strategic analysis, business planning, or evaluating situations from multiple perspectives.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Create a SWOT analysis with items for each of the four categories: Strengths, Weaknesses, Opportunities, and Threats.
        Each category should have 2-5 concise bullet points.`;
    }

    getPromptSchema() {
        return {
            strengths: ["array of 2-5 strength items"],
            weaknesses: ["array of 2-5 weakness items"],
            opportunities: ["array of 2-5 opportunity items"],
            threats: ["array of 2-5 threat items"]
        };
    }

    getSlideModels(model, options = {}) {
        let models = [
            this.buildSwotDiagram(model, options),
        ];

        return models;
    }

    buildSwotDiagram(model, options = {}) {
        let builder = new SlideModelBuilder("swot_diagram", model);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        builder.createPrimary({
            showCellChar: true,
            showCellTitle: true,
            showAxisLabel: false,
            items: [
                {
                    text: {
                        blocks: [
                            builder.createBlock("Strengths", TextStyleType.TITLE),
                            ...(model.strengths || []).map(text => builder.createBlock(text, TextStyleType.BODY))
                        ].filter(b => b)
                    }
                },
                {
                    text: {
                        blocks: [
                            builder.createBlock("Weaknesses", TextStyleType.TITLE),
                            ...(model.weaknesses || []).map(text => builder.createBlock(text, TextStyleType.BODY))
                        ].filter(b => b)
                    }
                },
                {
                    text: {
                        blocks: [
                            builder.createBlock("Opportunities", TextStyleType.TITLE),
                            ...(model.opportunities || []).map(text => builder.createBlock(text, TextStyleType.BODY))
                        ].filter(b => b)
                    }
                },
                {
                    text: {
                        blocks: [
                            builder.createBlock("Threats", TextStyleType.TITLE),
                            ...(model.threats || []).map(text => builder.createBlock(text, TextStyleType.BODY))
                        ].filter(b => b)
                    }
                }
            ]
        });

        if (options.citeSources) {
            builder.createSourcesAttribution(model.sources);
        }

        return builder.model;
    }
}
